module.exports = __webpack_public_path__ + "static/media/hackerMobile.c8155912.png";